import React from 'react'

export default function SignupBookkeeper() {
  const onSubmit = (e) => { e.preventDefault(); alert('Submit bookkeeper application (implement)') }
  return (
    <div style={{maxWidth:820, margin:'0 auto'}}>
      <section className="card">
        <h2 className="h2">Join as a Bookkeeper</h2>
        <p className="kv">Provide details and credentials to be vetted.</p>
        <form onSubmit={onSubmit} style={{display:'grid', gap:12, marginTop:12}}>
          <input className="input" placeholder="Full name" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" type="email" placeholder="Email" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" placeholder="Professional title (e.g. CPA)" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" placeholder="Specialties (comma separated)" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" placeholder="Hourly rate (USD)" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <textarea className="input" placeholder="Short bio / experience" style={{minHeight:100, padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <div className="kv">Upload credentials (PDF)</div>
          <input type="file" accept=".pdf,.png,.jpg" />
          <button className="btn primary" type="submit">Submit application</button>
        </form>
      </section>
    </div>
  )
}
